import {
  init,
  browserTracingIntegration,
  makeBrowserOfflineTransport,
  makeFetchTransport,
  httpContextIntegration,
  breadcrumbsIntegration,
  globalHandlersIntegration,
  linkedErrorsIntegration,
} from '@sentry/browser';
import { extraErrorDataIntegration } from '@sentry/integrations';
import { BaseTransportOptions } from '@sentry/types/types/transport';
import escapeStringRegexp from 'escape-string-regexp';
import { Environment } from 'src/types/Environment';

export function sentryInit(environment: Environment): void {
  if (environment.sentryDsn === '') {
    return;
  }

  init({
    dsn: environment.sentryDsn,
    environment: environment.sentryEnv,
    release: process.env.SENTRY_RELEASE,
    transport: makeBrowserOfflineTransport((options: BaseTransportOptions) => makeFetchTransport({
      ...options,
      // masking sentry_key because adblockers use it for blocking sentry
      url: options.url.replace(/sentry_key/, 'xauth'),
    })),
    tracePropagationTargets: [
      new RegExp(`^${escapeStringRegexp(environment.apiBaseUrl)}`),
    ],

    debug: false,
    enabled: true,

    normalizeDepth: 0,
    maxValueLength: 100_000,

    defaultIntegrations: false,
    integrations: [
      httpContextIntegration(),
      breadcrumbsIntegration({
        dom: true,
        xhr: true,
        fetch: true,
        console: true,
        history: true,
        sentry: true,
      }),
      globalHandlersIntegration({
        onerror: true,
        onunhandledrejection: true,
      }),
      extraErrorDataIntegration({
        depth: 1_000,
      }),
      linkedErrorsIntegration({
        key: 'previous',
        limit: 100,
      }),
      // browserTracingIntegration({
      //   traceXHR: true,
      //   traceFetch: true,
      //   enableHTTPTimings: true,
      // }),
    ],
    sampleRate: 0.0,
    profilesSampleRate: 0.0,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 0.0,
    tracesSampleRate: 0.0,
  });
}
